module.exports = __webpack_public_path__ + "img/3.58685dae.png";